import { render, staticRenderFns } from "./orgDetails.vue?vue&type=template&id=5e8a6048"
import script from "./orgDetails.vue?vue&type=script&lang=js"
export * from "./orgDetails.vue?vue&type=script&lang=js"
import style0 from "./orgDetails.vue?vue&type=style&index=0&id=5e8a6048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports